// assets/ds-smart-layout.js
// Pictoirel Design Studio - Dedicated Smart Layout Controller (v3.3)
// STRICT RULE: This script isolates manual layout actions (Fit, Fill, Panoramic, Add Image).
// It MUST NOT interact with or modify the core auto-fill layouting engine.
// Fit / Fill now preserve the user's current object position — only scale and crop change.

(function() {
  'use strict';

  var BLEED_W = 1000;
  var BLEED_H = 766;

  // ── Panoramic: Full-bleed stretch across the entire 2-page spread ─────────
  window.makePanoramic = function() {
      if (!window.fabricCanvas) return;
      var obj = window.fabricCanvas.getActiveObject();
      if (!obj || obj.type !== 'image' || obj.isPaper || obj.isPlaceholder) return;

      var origW = obj.originalWidth || obj.width;
      var origH = obj.originalHeight || obj.height;

      // Warn: panoramic is not suited for portrait-ratio images
      if (origH > origW) {
          if (window.showToast) window.showToast('Panoramic layout is not recommended for portrait photos.', 4000, 'error');
          return;
      }

      // Reset crop, center on spread, scale to full bleed
      obj.set({
          left: BLEED_W / 2,
          top: BLEED_H / 2,
          originX: 'center',
          originY: 'center',
          cropX: 0,
          cropY: 0,
          width: origW,
          height: origH,
          angle: 0
      });

      var scale = Math.max(BLEED_W / origW, BLEED_H / origH);
      obj.set({ scaleX: scale, scaleY: scale });
      obj.setCoords();
      window.fabricCanvas.renderAll();
      if (window.saveHistory) window.saveHistory();
  };

  // ── Toggle: switch between fit and fill on the active object ──────────────
  window.toggleFitFill = function() {
      if (!window.fabricCanvas) return;
      if (window._cropData) return;
      var obj = window.fabricCanvas.getActiveObject();
      if (!obj || obj.type !== 'image' || obj.isPaper || obj.isPlaceholder) return;
      var currentMode = obj._fitFillMode || 'fill';
      if (currentMode === 'fill') {
          window.applyFitMode();
      } else {
          window.applyFillMode();
      }
  };

  // ── Fit: contain full image within its current bounding box ───────────────
  window.applyFitMode = function() {
      if (!window.fabricCanvas) return;
      var obj = window.fabricCanvas.getActiveObject();
      if (!obj || obj.type !== 'image' || obj.isPaper || obj.isPlaceholder) return;
      _applyFitFill(obj, 'fit');
      var f = document.getElementById('btn-fit'); if (f) f.classList.add('is-active');
      var c = document.getElementById('btn-fill'); if (c) c.classList.remove('is-active');
  };

  // ── Fill: cover the bounding box, cropping edges as needed ───────────────
  window.applyFillMode = function() {
      if (!window.fabricCanvas) return;
      var obj = window.fabricCanvas.getActiveObject();
      if (!obj || obj.type !== 'image' || obj.isPaper || obj.isPlaceholder) return;
      _applyFitFill(obj, 'fill');
      var c = document.getElementById('btn-fill'); if (c) c.classList.add('is-active');
      var f = document.getElementById('btn-fit'); if (f) f.classList.remove('is-active');
  };

  // ── Core: adjust scale and crop only, never move the object ───────────────
  function _applyFitFill(obj, mode) {
      if (!obj) return;

      var origW = obj.originalWidth || obj.width;
      var origH = obj.originalHeight || obj.height;
      if (!origW || !origH) return;

      // The bounding box the image currently occupies on the canvas
      var boundingW = obj.width * obj.scaleX;
      var boundingH = obj.height * obj.scaleY;

      // If the image is uncropped (a raw uploaded photo), fit/fill against its own bounding box does nothing.
      // Instead, use the single page (500x766) it is currently on as the target bounding box.
      var isUncropped = (obj.cropX === 0 && obj.cropY === 0 && obj.width === origW && obj.height === origH);
      if (isUncropped) {
          boundingW = 500;
          boundingH = 766;
          // Center it on the page it currently resides
          var isLeftPage = obj.left < 500;
          obj.set({
              left: isLeftPage ? 250 : 750,
              top: 383
          });
      }

      if (mode === 'fit') {
          // Contain: shrink so the full image fits inside the current bounding box
          var scale = Math.min(boundingW / origW, boundingH / origH);
          obj.set({
              cropX: 0,
              cropY: 0,
              width: origW,
              height: origH,
              scaleX: scale,
              scaleY: scale,
              _fitFillMode: 'fit'
          });
      } else {
          // Fill: expand so the image covers the current bounding box, cropping edges
          var scale = Math.max(boundingW / origW, boundingH / origH);
          var cropW = boundingW / scale;
          var cropH = boundingH / scale;
          obj.set({
              cropX: Math.max(0, (origW - cropW) / 2),
              cropY: Math.max(0, (origH - cropH) / 2),
              width: cropW,
              height: cropH,
              scaleX: scale,
              scaleY: scale,
              _fitFillMode: 'fill'
          });
      }

      // CRITICAL: position is intentionally NOT changed — preserve user placement
      obj.setCoords();
      window.fabricCanvas.renderAll();
      if (window.saveHistory) window.saveHistory();
  }

  // Expose for potential external calls
  window.smartLayoutSingleImage = _applyFitFill;

})();
